import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './types/state';
import {
  isLoadingAnnualPlans,
  isLoadingActivities,
  isLoadingPlans,
  isLoadingFocuses,
  isLoadingObjectives,
  isLoadingRequirements,
  isLoadingChecklists,
  isLoadingChecklistsResponses,
  isLoadingSelfAssessmentResults,
} from './selectors';

export function isAnyLoading(state: RootState): boolean {
  return (
    isLoadingPlans(state) ||
    isLoadingAnnualPlans(state) ||
    isLoadingFocuses(state) ||
    isLoadingObjectives(state) ||
    isLoadingRequirements(state) ||
    isLoadingActivities(state) ||
    isLoadingChecklists(state) ||
    isLoadingChecklistsResponses(state) ||
    isLoadingSelfAssessmentResults(state)
  );
}

type UseAnyLoadingOptions =
  | number
  | {
      enterDelay?: number;
      exitDelay?: number;
    };

export function useAnyLoading(options?: UseAnyLoadingOptions) {
  const loading = useSelector(isAnyLoading);
  const [delayedLoading, setDelayedLoading] = useState(loading);

  let enterDelay = 0;
  let exitDelay = 350;

  if (typeof options === 'number') {
    exitDelay = options;
  } else if (options) {
    if (typeof options.enterDelay === 'number') enterDelay = options.enterDelay;
    if (typeof options.exitDelay === 'number') exitDelay = options.exitDelay;
  }

  useEffect(() => {
    let timeoutId: number | undefined;

    if (loading) {
      if (!delayedLoading) {
        timeoutId = window.setTimeout(() => setDelayedLoading(true), enterDelay);
      }
    } else if (delayedLoading) {
      timeoutId = window.setTimeout(() => setDelayedLoading(false), exitDelay);
    }

    return () => {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
    };
  }, [loading, delayedLoading, enterDelay, exitDelay]);

  return delayedLoading;
}
